'use client';

import classnames from 'classnames';

import type { LogoProps } from './Logo.types';
import { ReactComponent as CompanyIcon } from './icons/company-logo';
import { ReactComponent as Icon } from './icons/icon';
import { ReactComponent as LogoIcon } from './icons/logo';
import { ReactComponent as LogoHIcon } from './icons/logo-h';

import styles from './Logo.module.scss';

const MARKS = {
  icon: Icon,
  logo: LogoIcon,
  'logo-h': LogoHIcon,
  'company-logo': CompanyIcon,
};

function Logo({
  style,
  className,
  variant = 'logo',
  testId = 'ui-logo',
}: LogoProps) {
  // Labelling by variant also gives logo-h its own name: it used to announce
  // itself as "logo", indistinguishable from the stacked mark.
  const Mark = MARKS[variant];

  return (
    <div
      style={style}
      className={classnames(styles['wrapper'], className)}
      data-testid={testId}
    >
      <Mark className={styles['mark']} aria-label={variant} />
    </div>
  );
}

export { Logo };
